import { Navigate } from 'react-router'
import { useGetProfileQuery } from '../../Redux/Apis/authApi'

/**
 * The current admin's effective permissions, read straight from the profile
 * response (the backend is the only source of truth). Super admins implicitly
 * pass every check.
 */
export const usePermissions = () => {
    const { data } = useGetProfileQuery()
    const isSuperAdmin = Boolean(data?.data?.isSuperAdmin)
    const permissions = data?.data?.permissions || []
    const can = (permission) => isSuperAdmin || !permission || permissions.includes(permission)
    return { can, isSuperAdmin, permissions }
}

/**
 * Renders `children` only when the current admin holds `permission`; otherwise
 * renders `fallback` (null by default). Use to gate screens, sidebar items and
 * action buttons.
 */
const Can = ({ permission, children, fallback = null }) => {
    const { can } = usePermissions()
    return can(permission) ? children : fallback
}

/**
 * Route guard: renders children only if the admin holds `permission`, otherwise
 * redirects to the dashboard home. Safe to use after AdminRoutes (which has
 * already resolved the profile), so `can` is reliable here.
 */
export const RequirePermission = ({ permission, children }) => {
    const { can } = usePermissions()
    return can(permission) ? children : <Navigate to="/" replace />
}

export default Can
